export enum quotationsListTypes {
    GET_QUOTATIONS_LIST = '@@quotationsList/GET_QUOTATIONS_LIST',
    GET_QUOTATIONS_LIST_SUCCESS = '@@quotationsList/GET_QUOTATIONS_LIST_SUCCESS',
    GET_QUOTATIONS_LIST_FAIL = '@@quotationsList/GET_QUOTATIONS_LIST_FAIL',

    GET_MILESTONESCONFIG_QT = '@QT/GET_MILESTONECONFIG',
    GET_MILESTONESCONFIG_QT_SUCCESS = '@QT/GET_MILESTONECONFIG_SUCCESS',
    GET_MILESTONESCONFIG_QT_FAIL = '@QT/GET_MILESTONECONFIG_FAIL',
}
